import i18n from '@/i18n'

// 公共方法

//loading
export const loading = () => {
  var mask = '<div class="mask"></div>',
    load = '<div class="loadEffect"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>'
  var lBox = document.getElementById('loading')
  if(!lBox) {
    lBox = document.createElement('div')
    lBox.id = "loading"
  }
  lBox.innerHTML = mask + load
  document.getElementsByTagName('body')[0].appendChild(lBox)
}
export const hideLoading = () => {
  var lBox = document.getElementById('loading');
  (!!lBox) && (lBox.innerHTML = '')
}
// 获取token
export const getToken = () => {
  return (null == getStorage('token')) ? "" : getStorage('token')
}
// 设置token（默认保留1天）
export const setToken = (value) => {
  var Days = 1
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = "token=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/"
}

var db = sessionStorage
export const getStorage = (name) => {
  if(!window.sessionStorage) {
    console.log('浏览暂不支持sessionStorage')
  }
  return sessionStorage.getItem(name)
}

export const setStorage = (name, value) => {
  sessionStorage.setItem(name, value)
  return sessionStorage
}

export const removeStorage = (name) => {
  return sessionStorage.removeItem(name)
}
// 删除所有cookie
export const clearStorage = () => {
  sessionStorage.clear()
  return sessionStorage
}

// 获取中心点
export const getCoordinate = (element) => {
  var actualLeft = element.offsetLeft,
    actualTop = element.offsetTop,
    current = element.offsetParent

  while(current !== null) {
    actualLeft += current.offsetLeft
    actualTop += current.offsetTop
    current = current.offsetParent
  }
  return {
    left: actualLeft,
    top: actualTop
  }
}
// 拷贝
export const cloneObj = function(obj) {
  var str, newobj = obj.constructor === Array ? [] : {}
  if(typeof obj !== 'object') {
    return
  } else if(window.JSON) {
    str = JSON.stringify(obj),
      newobj = JSON.parse(str)           // 还原
  } else {
    for(var i in obj) {
      newobj[i] == typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i]
    }
  }
  return newobj
}
// 验证是否是一个空对象或空数组
export const isEmptyObjOrArr = function(obj) {
  if(obj == "" || obj == null || obj == undefined) return true
  if(obj instanceof Array) {
    if(JSON.stringify(obj) === '[]') {
      return true                           // 空对象 数组
    }
    return false
  } else {
    if(JSON.stringify(obj) === "{}") {
      return true                           // 空对象
    }
    return false
  }
}
//验证邮箱格式
export const checkEmail = (str) => {
  var reg = /^[a-z0-9A-Z]+([\-_\.][a-z0-9A-Z]+)*@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)*\.)+[a-zA-Z]+$/
  return reg.test(str)
}
//验证手机格式
export const checkPhone = (str) => {
  var reg = /^1[0-9]{10}$/
  return reg.test(str)
}

export function getLanguage() {
  return i18n.locale || localStorage.getItem("language") || 'zh'
}

export function setLanguage(lang) {
   i18n.locale = lang
}

export const isDevEnv = process.env.NODE_ENV === "development"

//常量

export const documentsUrl = "https://hotdb-community.github.io/hotdb-documents"
export const getDocumentUrl = () => `${documentsUrl}/#/${getLanguage()}/`
export const downloadDocumentsUrl = "https://hotpu-1257128263.cos.ap-shanghai.myqcloud.com/%E5%AF%B9%E5%A4%96%E5%BC%80%E6%94%BE%E4%B8%8B%E8%BD%BD%E6%96%87%E6%A1%A3/%E7%83%AD%E7%92%9E%E6%95%B0%E6%8D%AE%E5%BA%93HotDB%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C-2.5.6--V2.0.rar"



// WEBPACK FOOTER //
// ./src/utils/index.js